<template>
  <main class="min-h-screen grid place-items-center p-4 bg-brand">
    <section class="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl" aria-label="Autentikasi">
      <h1 class="text-2xl font-extrabold text-brand mb-6">Delcom Auction</h1>
      <RouterView />
    </section>
  </main>
</template>
